module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/407.642382f7.png";